<template>
  <div>
    <v-card class="ma-2" max-width="100%">
      <v-row>
        <v-card-title class="primary--text mt-3"
          ><v-btn @click="back" class="ml-n2 primary--text" text>
            <v-icon>mdi-reply</v-icon></v-btn
          >
          Card Users
          <span
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left font-weight: 20 primary--text ml-2"
            >(Details of Glyd Card Users)</span
          >
        </v-card-title>
      </v-row>
      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab
          v-for="item in tabItems"
          :key="item"
          name="item"
          @click="tabInfo(item)"
          >{{ item }}</v-tab
        >
      </v-tabs>
    </v-card>
    <HistoryEmployees v-if="tab == 0" />
    <CreateEmployees v-if="tab == 1" />
  </div>
</template>
<script>
import CreateEmployees from "@/Views/Employees/CreateEmployees.vue";
import HistoryEmployees from "@/Views/Employees/HistoryEmployees.vue";
// import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: {
    CreateEmployees,
    HistoryEmployees,
  },
  data: () => ({
    tab: 0,
    tabItems: ["View Card Users"],
  }),
  // created() {
  //   this.checkacces();
  // },
  methods: {
    back() {
      this.$router.push("/Dashboard");
    },
    // async checkacces() {
    //   var inputData = {
    //     method_name: "ACCESS",
    //     page_no: 0,
    //     record_count: 0,
    //     page_size: 25,
    //     app_code: "CPORTAL",
    //     method_param: {
    //       action: "CHECK_ACCESS",
    //       user_id: this.$store.getters.get_userid,
    //       module_code: "CUSERS",
    //       module_type: "2",
    //     },
    //   };
    //   var responseData = await apiCall(inputData);
    //   //  console.log(responseData, "responsCHECK_ACCESSeData");
    //   var checkaccessdata = responseData.data.data;
    //   // checkaccessdata.is_approver = false;
    //   // checkaccessdata.is_checker = false;
    //   // checkaccessdata.is_maker = false;
    //   // checkaccessdata.is_viewer = false;
    //   if (
    //     checkaccessdata.is_approver == false &&
    //     checkaccessdata.is_checker == false &&
    //     checkaccessdata.is_maker == false &&
    //     checkaccessdata.is_viewer == false
    //   ) {
    //     this.$router.push("/accessdenied");
    //   }
    // },
  },
};
</script>
